import React from 'react'
import Images from "../../components/Images/Images"

const Header = ({ _image }) => {
    // const title = "¡Aprovecha los increibles descuentos!"
    // const imageXs = _image.xs.url
    const imagetablet = _image.md.url
    const image1024 = _image.lg.url
    const imagelg = _image.url

    return (
        <div className="promotions_container--header">
            <div className="promotions_container--image">
                <Images
                    sources={{
                        mb: { url: imagetablet },
                        sm: { url: imagetablet },
                        md: { url: image1024 },
                        lg: { url: imagelg },
                        url: imagelg
                    }}
                    alt="Promotions Header Image"
                    loading="eager"
                    className="imagen_header"
                />
            </div>
            {/* <div className="promotions_container--title">
              <p>{title}</p>
            </div> */}
        </div>
    )
}

export default Header
